import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const askRedoExplorerFilters = z.object({
  agentNames: z.array(z.string()).default(["ask-redo-v1"]),
  searchQuery: z.string().optional(),
  escalationFilter: createEnum(["yes", "no"]).optional(),
  skillFilter: z.string().optional(),
  toolFilter: z.string().optional(),
  productAreaFilter: z.string().optional(),
  sourceFilter: z.string().optional(),
  teamIdFilter: z.string().optional(),
  dateRange: z
    .object({ start: z.date().nullable(), end: z.date().nullable() })
    .optional(),
});

export const askRedoExplorerThread = z.object({
  _id: z.string(),
  agentName: z.string(),
  teamId: z.string().nullable(),
  teamName: z.string().nullable(),
  userEmail: z.string().nullable(),
  source: z.string().nullable(),
  createdAt: z.date(),
  updatedAt: z.date().nullable(),
  messageCount: z.number(),
  totalTokens: z.number(),
  hasEscalation: z.boolean(),
  escalationCategory: z.string().nullable(),
  subcategoryLabel: z.string().nullable(),
  intercomConversationIds: z.array(z.string()),
  skills: z.array(z.string()),
  tools: z.array(z.string()),
  productAreas: z.array(z.string()),
  calledAgents: z.array(z.string()),
});

export const getAskRedoExplorerThreads = {
  name: "getAskRedoExplorerThreads" as const,

  input: askRedoExplorerFilters.extend({
    page: z.number().min(1).default(1),
    pageSize: z.number().min(1).max(100).default(25),
  }),

  output: z.object({
    threads: z.array(askRedoExplorerThread),
    totalCount: z.number(),
  }),
};
